<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else id="page" class="min-h-screen w-full">
    <div class="">
      <Navbar
        id="header"
        class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
      >
      </Navbar>

      <div class="mt-5 px-10">
        <router-link
          :to="{ path: '/results/' + survey.id }"
          class="px-4 font-normal align-middle text-sm border border-transparent cursor-pointer rounded text-gray-400 hover:no-underline hover:text-purple-400"
        >
          <svg-icon
            icon="heroicons/outline/arrow-left"
            class="h-4 w-4 inline-block align-middle"
          ></svg-icon>
          Back to results
        </router-link>
      </div>

      <!--Delete Modal -->
      <BaseModal
        :showModal="showDeleteModal"
        v-on:close="showDeleteModal = false"
        v-on:confirm="
          deleteResponses();
          showDeleteModal = false;
        "
      >
        <template v-slot:body>
          <p class="text-sm text-gray-500">
            Are you sure you want to delete all of this visitor's responses?
            This action cannot be undone.
          </p>
        </template>
      </BaseModal>

      <div class="mt-10 px-10">
        <!-- Start -->

        <div class="max-w-5xl mx-auto">

          <div class="flex flex-row justify-between px-4">
          <div class="max-w-5xl text-lg font-bold pb-5">
            {{ survey.name }} </div>


          <div v-if="webhooks.length > 0" @click="sendWebhook" class="cursor-pointer"> 
          


              <button
                class="py-2 block bg-white font-normal text-sm border border-solid border-gray-400 rounded-md shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                type="button"
                style="transition: all .15s ease"
              >
                
                <div class="mx-4 flex flex-row items-end"
                  >Send Webhook 
                  <div v-if="sending" class="spinner ml-3 h-4 w-4 border-2"></div>
                  <svg-icon v-else icon="heroicons/outline/external-link" class="h-4 w-4 ml-3"></svg-icon>
                </div>
              </button>

          </div>
          </div>

          
          <div class="bg-white shadow overflow-hidden sm:rounded-lg ">
            <div class="px-4 py-5 sm:px-6">
              <div class="flex flex-row justify-between items-center">
                <div>
                  <h3 class="text-base leading-6 font-medium text-gray-800">
                    {{ dataset.name }} {{ dataset.email }}
                  </h3>
                  <div class="mt-1 max-w-2xl text-sm text-gray-500">
                    Created at {{ new Date(Date.parse(dataset.created_at)) }}
                  </div>
                </div>

                <div @click="confirmDelete">
                  <svg-icon
                    icon="heroicons/outline/trash"
                    class="h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-400"
                  />
                </div>
              </div>
            </div>

            <div class="border-t border-b border-gray-200">
              <div
                v-if="dataset.fields && dataset.fields.length > 0"
                class="px-4 py-5 sm:px-6 bg-gray-50"
              >
                Form Fields:
              </div>

              <div v-for="(field, index) in dataset.fields" :key="field.id">
                <div class="px-4 py-5 sm:px-6" :class="rowColor(index)">
                  <div class="font-medium text-gray-600">
                    
                             <div
                    class="font-medium text-gray-600 flex flex-row justify-between"
                  >

                    <div class="flex flex-row">
                      <div
                        class="inline-block py-1 px-3 mr-2 text-sm bg-purple-300 rounded border-solid border-purple-400 font-bold"
                      >
                        {{ Number(index) + 1 }}
                      </div>

                      <div v-text="field.name.charAt(0).toUpperCase() + field.name.slice(1)"> </div>

                    </div>

                      <click-to-edit
                        :value="field.name"
                        @input="inputFieldName($event, field)"
                        @update="updateFieldName($event, field.id)"
                        pClass=" text-gray-400 font-normal block px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
                        inputClass="text-gray-400 font-normal block px-5 cursor-pointer rounded align-middle"
                        :pStyle="{
                          width: 'fit-content',
                          'min-height': '1.1rem',
                        }"
                        :inputStyle="{ 'min-height': '1.1rem' }"
                      ></click-to-edit>
                    </div>


                  </div>

                  <div
                    class="text-sm text-gray-900 sm:mt-2"
                    v-text="field.value"
                  ></div>
                </div>
              </div>
              <div
                class="flex flex-row justify-between bg-gray-50 border-t border-b border-gray-200 px-4 py-5"
              >
                <div class="">
                  Multiple Choice Questions:
                </div>
                <div class="mr-4 my-auto">
                  Reference Id
                </div>
              </div>

              <div v-for="(result, index) in dataset.results" :key="result.id">
                <div class="px-4 py-5 sm:px-6" :class="rowColor(index)">
                  <div
                    class="font-medium text-gray-600 flex flex-row justify-between"
                  >
                    <div class="flex flex-row">
                      <div
                        class="inline-block py-1 px-3 mr-2 text-sm bg-purple-300 rounded border-solid border-purple-400 font-bold"
                      >
                        {{ index + 1 }}
                      </div>

                      <click-to-edit
                        :value="getTitle(result.id)"
                        @update="updateTitle($event, result.id)"
                        pClass=" block px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
                        inputClass=" block px-5 cursor-pointer rounded align-middle w-full"
                        :pStyle="{
                          width: 'fit-content',
                          'min-height': '1.1rem',
                        }"
                        :inputStyle="{ 'min-height': '1.1rem' }"
                      ></click-to-edit>
                    </div>

                    <div class="flex flex-row">
                      <click-to-edit
                        :value="getRef(result.id)"
                        @update="updateRef($event, result.id)"
                        pClass="text-gray-400 font-normal block px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
                        inputClass="text-gray-400 font-normal block px-5 cursor-pointer rounded align-middle "
                        :pStyle="{
                          width: 'fit-content',
                          'min-height': '1.1rem',
                        }"
                        :inputStyle="{ 'min-height': '1.1rem' }"
                      ></click-to-edit>
                    </div>
                  </div>

                  <div
                    class="text-sm text-gray-900 sm:mt-2"
                    v-text="result.value"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Header";
//import SidebarComponent from "@/components/CreativeTim/Sidebar.vue";
import Survey from "@/models/Survey";
import Step from "@/models/Step";
import Response from "@/models/Response";
import Visitor from "@/models/Visitor";
import FormField from "@/models/content/FormField";
import router from "@/router/route.js";
import axios from "axios";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "Result",
  components: {
    Navbar,
    ClickToEdit,
    //SidebarComponent,
  },
  data() {
    return {
      loading: false,
      downloading: false,
      showDeleteModal: false,
      sending: false,
      dataset: [],
    };
  },
  props: ["surveyid", "visitorid"],
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("steps", (query) => {
          query.orderBy("order", "asc").with("options");
        })
        .with("integrations", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    steps() {
      //steps that have multiple choice options
      return this.survey.steps.filter((step) => step.options.length > 0);
    },
    webhooks() {
      //get any webhooks that have been created for this campaign
      return this.survey.integrations.filter(integration => integration.type == 'WEBHOOK' );
    },
    /*
    visitor() {
      return Visitor.query()
        .where("id", this.visitorid)
        .first();
    },
    */
  },
  methods: {
    async init() {
      var id = this.surveyid || null;

      if (id === null) {
        console.log("Error, survey not found.");
        router.push({ name: "campaign-list" });
      }

      this.loading = true;

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      }

      //if visitor is not already loaded in state, try to load it from server
      if (this.visitor === null) {
        await Visitor.api().get("/api/visitor/" + this.visitorid, {
          dataKey: "data",
        });
      }
      this.loadResponses();

      this.loading = false;
    },
    getTitle(id) {
      let step = Step.find(id);
      return step.title || "Step " + step.order;
    },
    getRef(id) {
      let step = Step.find(id);
      return step.ref_id;
    },
    async sendWebhook(){
      this.sending = true;
      try {
        await Survey.api().get(`/api/webhook/call/survey/${this.survey.id}/visitor/${this.visitorid}`);
      } catch (err) {
        console.log(err);
        //TO DO: Handle errors
      }
      this.sending = false;
    },
    /*
    getResult(stepid) {
      if (typeof this.dataset.results !== "undefined")
        return this.dataset.results[stepid];
      else return "(No response received.)";
    },
    */
    //Retrieve this visitor's responses from server and load to this.dataset
    loadResponses() {
      axios
        .get(`api/response/survey/${this.surveyid}/visitor/${this.visitorid}`)
        .then((response) => {
          this.dataset = response.data.data;
          this.fields;
        })
        //if user request fails
        .catch(() => {
          //
        });
    },

    rowColor(index) {
      //check if even numbered row
      if (index % 2 == 0) return "bg-white";
      else return "bg-gray-50";
    },
    confirmDelete() {
      this.showDeleteModal = true;
    },
    async updateTitle(value, id) {
      //if (value !== step.title) {
      let step = await Step.update({ where: id, data: { title: value } });

      try {
        var post = await Step.api().post(`/api/step/update/${id}`, step);
      } catch (err) {
        //Log error
        this.$store.dispatch("notification/add", {
          message: "An error occured updating value. Please try again.",
        });
      }
      //}
    },
    async updateRef(value, id) {
      //if (value !== step.ref) {
      let step = await Step.update({ where: id, data: { ref_id: value } });
      try {
        var post = await Step.api().post(`/api/step/update/${id}`, step);
      } catch (err) {
        //Log error
        this.$store.dispatch("notification/add", {
          message: "An error occured updating value. Please try again.",
        });
      }
      //}
    },
    async updateFieldName(value, id) {
      //if (value !== step.ref) {
      //let field = await FormField.update({ where: id, data: { name: value } });
      try {
        await FormField.api().post(`/api/content/update/${id}`, {
          name: value,
        });

        this.dataset.fields.forEach((field, index, array) => {
          if (field.id === id) {
            field.name = value;
            this.$set(array, index, field);
          }
        });
      } catch (err) {
        //Log error
        this.$store.dispatch("notification/add", {
          message: "An error occured saving value. Please try again.",
        });
      }
      //}
    },
    inputFieldName(event, field) {
      field.name = event.target.value;
    },
    async deleteResponses() {
    //Delete responses from database

      var self = this;

      await Response.api()
        .delete(
          `/api/response/delete/${this.survey.id}/visitor/${this.visitorid}`
        )
        .then(() => {
          //After server delete, delete responses from entities state
          Response.delete((response) => {
            return (
              response.visitor_id == this.visitorid &&
              response.survey_id == this.survey.id
            );
          });

          // send back to all results page
          router.push({ path: "/results/" + this.survey.id });
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
          self.$store.dispatch("notification/add", {
            message: "An error occured deleting visitor responses.",
          });
        });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style></style>
